// faq.js
import req from './axios';
import { isMockJs } from './axios'


export const faq = () => req('get', isMockJs ? '/faq/faq' : '/faq/');

export const voteUp = (sendData) => req('post', isMockJs ? '/faq/voteUp' : `/faq/${sendData.id}/upvote/`);

export const voteDown = (sendData) => req('post', isMockJs ? '/faq/voteDown' : `/faq/${sendData.id}/downvote/`);
